import semver from 'semver';
/*
 * Check if the MFE supports re-rendering itself when data changes
 *
 * `bundledWith.@servicetitan/web-components` is checked first, as that guarantees support
 * `dependencies.@servicetitan/web-components` is checked second, in the case of the MFE's startup
 *      hasn't been updated to add web-components to bundledWith yet, and the MFE's web-component
 *      dependency is set in it's own package's package.json instead of the monorepo's root package.json
 * `bundledWith.@servicetitan/startup` is checked third, with the hope that the startup version
 *      matches web-components
 */
export function getMFESupportsRerendering(bundledWith, dependencies) {
    var _a, _b;
    return !!((_b = (_a = isSupportedVersion(bundledWith === null || bundledWith === void 0 ? void 0 : bundledWith['@servicetitan/web-components'])) !== null && _a !== void 0 ? _a : isSupportedVersion(dependencies === null || dependencies === void 0 ? void 0 : dependencies['@servicetitan/web-components'])) !== null && _b !== void 0 ? _b : isSupportedVersion(bundledWith === null || bundledWith === void 0 ? void 0 : bundledWith['@servicetitan/startup']));
}
function isSupportedVersion(version) {
    const minVersion = version && semver.minVersion(version);
    if (minVersion) {
        return semver.gte(minVersion, '22.12.0');
    }
}
//# sourceMappingURL=get-mfe-supports-rerendering.js.map